<template>
  <AppOffcanvas
    :model-value="offcanvasVisible"
    title="Buscador de Clientes"
    width="520px"
    :backdrop="false"
    @update:model-value="closeOffcanvas">
    <!-- Filtros -->
    <div class="space-y-4">
      <AppCard title="Filtros">
        <template #actions>
          <AppButton
            variant="ghost"
            size="sm"
            @click="limpiarFiltros">
            Limpiar
          </AppButton>
          <AppButton
            size="sm"
            @click="buscarClientes">
            Buscar
          </AppButton>
        </template>
        <div class="grid grid-cols-2 gap-3">
          <AppInput
            v-model="filtros.codigo"
            label="Código"
            placeholder="Código cliente"
            class="col-span-2"
            @keypress="buscarEnter" />
          <AppInput
            v-model="filtros.nombres"
            label="Nombre"
            placeholder="Nombre"
            @keypress="buscarEnter" />
          <AppInput
            v-model="filtros.apellidos"
            label="Apellido"
            placeholder="Apellido"
            @keypress="buscarEnter" />
          <AppInput
            v-model="filtros.email"
            label="Email"
            placeholder="email@ejemplo.com"
            type="email"
            class="col-span-2"
            @keypress="buscarEnter" />
        </div>
      </AppCard>

      <!-- Resultados -->
      <AppCard title="Listado">
        <AppTable
          :columns="columns"
          :rows="clientes"
          :hover="true">
          <template #empty>
            <p class="text-sm text-muted">Sin clientes encontrados</p>
          </template>
          <template #cell-codigo="{ row }">
            <button
              class="text-sm text-left w-full"
              @click="selectCustomer(row)">
              {{ row.codigo }}
            </button>
          </template>
          <template #cell-nombres="{ row }">
            <button
              class="text-sm text-left w-full"
              @click="selectCustomer(row)">
              {{ row.nombres }}
            </button>
          </template>
          <template #cell-apellidos="{ row }">
            <button
              class="text-sm text-left w-full"
              @click="selectCustomer(row)">
              {{ row.apellidos }}
            </button>
          </template>
          <template #cell-email="{ row }">
            <button
              class="text-sm text-left w-full text-brand hover:underline"
              @click="selectCustomer(row)">
              {{ row.email }}
            </button>
          </template>
        </AppTable>
      </AppCard>
    </div>
  </AppOffcanvas>
</template>

<script>
import { reactive, toRefs, computed, onMounted } from 'vue'
import { useStore } from 'vuex'
import { clienteService } from '@/_services/cliente.api'
import AppOffcanvas from './ui/AppOffcanvas.vue'
import AppCard from './ui/AppCard.vue'
import AppInput from './ui/AppInput.vue'
import AppButton from './ui/AppButton.vue'
import AppTable from './ui/AppTable.vue'

const columns = [
  { key: 'codigo', label: 'Código' },
  { key: 'nombres', label: 'Nombre' },
  { key: 'apellidos', label: 'Apellido' },
  { key: 'email', label: 'Email' },
]

export default {
  name: 'CustomerOffcanvas',
  components: { AppOffcanvas, AppCard, AppInput, AppButton, AppTable },
  setup() {
    const store = useStore()
    const state = reactive({
      filtros: { nombres: '', apellidos: '', codigo: '', email: '', page: 1, pageSize: 10 },
      clientes: [],
    })

    const getClientes = async () => {
      try {
        const res = await clienteService.getAllFilter(state.filtros)
        if (res.status !== 200) return
        state.clientes = res.data
      } catch {}
    }

    const limpiarFiltros = () => {
      state.filtros.nombres = ''
      state.filtros.apellidos = ''
      state.filtros.codigo = ''
      state.filtros.email = ''
    }

    const buscarClientes = () => getClientes()

    const closeOffcanvas = () => store.commit('setOffcanvasVisible', false)

    const selectCustomer = cliente => {
      store.commit('setSelectedCustomer', cliente)
      store.commit('setOffcanvasVisible', false)
    }

    const buscarEnter = async e => {
      if (e.keyCode === 13) await buscarClientes()
    }

    onMounted(async () => {
      store.commit('setSelectedCustomer', null)
      await getClientes()
    })

    return {
      ...toRefs(state),
      columns,
      offcanvasVisible: computed(() => store.state.offcanvasVisible),
      limpiarFiltros,
      buscarClientes,
      closeOffcanvas,
      selectCustomer,
      buscarEnter,
    }
  },
}
</script>
